import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import { api, formatDateTime } from "../lib/api";
import { Send, ArrowLeft, FileText } from "lucide-react";

export default function TocOnlineHistory() {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/toconline/batches").then(({ data }) => { setBatches(data); }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="paper-grain min-h-screen">
      <Header />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8" data-testid="toconline-history">
        <Link to="/contabilista" className="inline-flex items-center gap-2 text-sm text-[color:var(--ink-muted)] hover:text-[color:var(--ink)] mb-4" data-testid="back-to-dashboard">
          <ArrowLeft size={16} /> Voltar
        </Link>
        <span className="label-eyebrow">histórico</span>
        <h1 className="font-display text-3xl sm:text-4xl mt-2">Envios para TocOnline</h1>

        <div className="card-soft mt-6 p-0 overflow-hidden">
          {loading ? <div className="p-6 text-[color:var(--ink-muted)]">A carregar…</div> :
           batches.length === 0 ? (
            <div className="p-10 text-center text-[color:var(--ink-muted)]" data-testid="history-empty">
              <FileText className="mx-auto" size={28} />
              <p className="mt-3">Ainda nenhum envio.</p>
            </div>
           ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[color:var(--paper)] text-[color:var(--ink-muted)] uppercase text-xs tracking-wider">
                  <th className="text-left p-4">Enviado em</th>
                  <th className="text-left p-4">Cliente</th>
                  <th className="text-left p-4">Destinatário</th>
                  <th className="text-right p-4">Faturas</th>
                  <th className="text-right p-4">Emails</th>
                  <th className="text-left p-4">Por</th>
                </tr>
              </thead>
              <tbody>
                {batches.map((b) => (
                  <tr key={b.id} className="border-t border-[color:var(--border)] row-hover" data-testid={`batch-${b.id}`}>
                    <td className="p-4 font-mono-data text-xs">{formatDateTime(b.sent_at)}</td>
                    <td className="p-4"><div className="font-medium">{b.company_name}</div><div className="text-xs text-[color:var(--ink-muted)] font-mono-data">NIF {b.company_nif}</div></td>
                    <td className="p-4 font-mono-data text-xs">{b.to_email}</td>
                    <td className="p-4 text-right font-mono-data">{(b.invoice_ids || []).length}</td>
                    <td className="p-4 text-right font-mono-data inline-flex items-center gap-1 justify-end w-full"><Send size={12}/> {b.emails_count}</td>
                    <td className="p-4 text-xs text-[color:var(--ink-muted)]">{b.accountant_email}</td>
                  </tr>
                ))}
              </tbody>
            </table>
           )}
        </div>
      </main>
    </div>
  );
}
